<template>
    <section
        class="relative bg-gradient-to-t from-transparent via-accent/10 via-35% to-transparent">
        <div class="container flex items-center justify-between">
            <AtomTitle>
                <span v-html="sectionTitle" />
            </AtomTitle>
            <div class="hidden gap-3 md:flex">
                <ArrowButton
                    id="portfolio-prev"
                    aria-label="Предыдущее порфтолио"
                    class="rotate-180" />
                <ArrowButton
                    id="portfolio-next"
                    aria-label="Следующее порфтолио" />
            </div>
        </div>
        <div class="container mt-5 md:mt-10">
            <div class="swiper swiper-portfolio">
                <div class="swiper-wrapper items-stretch">
                    <div
                        v-for="(portfolio, index) in items"
                        :key="index"
                        class="swiper-slide max-md:!w-[17.5rem] max-sm:!h-auto sm:max-md:!h-[24.75rem] md:!h-auto">
                        <div
                            class="swiper-slide__inner max-sm:!h-full sm:!h-[24.75rem] md:!h-full">
                            <PortfolioCard
                                :portfolio
                                class="md:!h-full" />
                        </div>
                    </div>
                    <div
                        class="swiper-slide max-md:!w-[17.5rem] max-sm:!h-auto sm:max-md:!h-[24.75rem] md:!h-auto">
                        <div
                            class="swiper-slide__inner sm:!h-[24.75rem] md:!h-full">
                            <SpecialCard special-type="portfolio" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="!isPortfolio"
            class="mt-10 text-center md:mt-20">
            <BaseLink
                to="/portfolio"
                target="_blank"
                icon-right="arrow-right"
                size="accent">
                В портфолио
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import type {
    TCromiRentDirectionSlug,
    TDirectionSlug,
} from '~/types/global.types'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import ArrowButton from '~/components/base/arrow-button/ArrowButton.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import PortfolioCard from '~/components/particles/portfolio-card/PortfolioCard.vue'
import type { IPortfolioItem } from '~/components/particles/portfolio-section/portfolio-section.types'
import SpecialCard from '~/components/particles/special-card/SpecialCard.vue'

const route = useRoute()

const isPortfolio = computed(() => route.fullPath.split('/')[1] === 'portfolio')

interface Props {
    title?: string
    directionSlug?: TDirectionSlug | TCromiRentDirectionSlug
    items: IPortfolioItem[]
}

const props = withDefaults(defineProps<Props>(), {
    title: '',
    directionSlug: 'radioguide',
})

const sectionTitle = computed<string>(() => {
    if (props.title) return props.title

    switch (props.directionSlug) {
        case 'radioguide': {
            return `Интересные проекты с&nbsp;нашими радиогидами`
        }
        case 'audioguide': {
            return `Интересные проекты с&nbsp;нашими аудиогидами`
        }
        case 'sinhroperevod': {
            return `Интересные проекты с&nbsp;нашим оборудованием`
        }
        case 'cabin': {
            return `Интересные проекты с&nbsp;нашими кабинами`
        }
        case 'conference-system': {
            return `Интересные проекты с&nbsp;нашим оборудованием`
        }
        case 'dostupsreda': {
            return `Интересные проекты с&nbsp;нашими радиосистемами`
        }
        case 'arenda-radioguides': {
            return 'Обеспечили оборудованием более 16000 мероприятий'
        }
        case 'arenda-audioguides': {
            return 'Обеспечили оборудованием более 16000 мероприятий'
        }
        case 'arenda-video': {
            return 'Обеспечили оборудованием более 16000 мероприятий'
        }
        case 'arenda-zvuka': {
            return 'Обеспечили оборудованием более 16000 мероприятий'
        }
        case 'arenda-konferents-system': {
            return 'Обеспечили оборудованием более 16000 мероприятий'
        }
        case 'arenda-oborudovanie-dlya-sinhronnogo-perevoda': {
            return 'Обеспечили оборудованием более 16000 мероприятий'
        }
        default: {
            return 'Портфолио'
        }
    }
})

onMounted(() => {
    new Swiper('.swiper-portfolio', {
        modules: [Navigation],
        navigation: {
            prevEl: '#portfolio-prev',
            nextEl: '#portfolio-next',
        },
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            320: {
                spaceBetween: 8,
            },
            375: {
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    })
})

// const organization = getSeoOrganization()
// useSchemaOrg([
//     defineWebPage({
//         mainEntity: [
//             defineItemList({
//                 numberOfItems: props.items.length,
//                 itemListElement: props.items.map((item) => {
//                     const mainImage = item.image_main
//                         ? item.image_main[0]
//                         : null
//                     return defineListItem({
//                         item: defineArticle({
//                             '@type': 'BlogPosting',
//                             headline: item.name,
//                             url: useRoute().fullPath + item.slug,
//                             description: item.description,
//                             ...(mainImage && {
//                                 image: defineSeoImage(mainImage),
//                             }),
//                             author: defineOrganization(organization),
//                         }),
//                     })
//                 }),
//             }),
//         ],
//     }),
// ])
</script>
